var styleDataHash = "918fe999";
const injectCss = (() => {
  var css = `@charset "UTF-8";.ReactModalPortal,.glob_fontElementMap,.qu2Ke,.vaKB-,button{font-family:var(--ricos-font-family,unset)}.lpoW1{display:flex}.x7f4Y:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.UOJ5k,.x7f4Y:hover{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}.UOJ5k{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.kVlo3 .UOJ5k{box-shadow:none!important}.kVlo3 :is([data-resize-handle],[data-hook=image-corner-radius-handle],[data-hook=image-corner-radius-label]){display:none!important}.a-s3R{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.a-s3R.ehfU8{pointer-events:none}.q-4eH ::selection{background:transparent}.kbRkb{display:none}.vaKB-{position:relative}.KWwEj{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{direction:ltr;font-weight:300}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.EwyUV{color:#333;text-decoration:none}.Z2GGR{display:block}.dstGj{position:relative}.Eh-BR{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}.Eh-BR._8bZ-K::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}.Eh-BR.hJA42::-webkit-scrollbar-thumb{background-color:transparent}.YkM24{max-width:max-content!important;min-width:100%}.Eh-BR::-webkit-scrollbar{-webkit-appearance:none}.Eh-BR::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.Eh-BR::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "fontElementMap": "qu2Ke",
  "pluginContainer": "vaKB-",
  "flex": "lpoW1",
  "isFocusable": "x7f4Y",
  "hasFocus": "UOJ5k",
  "dragImageView": "kVlo3",
  "overlay": "a-s3R",
  "noPointerEventsOnFocus": "ehfU8",
  "hideTextSelection": "q-4eH",
  "hidden": "kbRkb",
  "pluginContainerMobile": "KWwEj",
  "isImage": "EwyUV",
  "anchor": "Z2GGR",
  "horizontalScrollbarWrapper": "dstGj",
  "pluginWithHorizontalScrollbar": "Eh-BR",
  "show": "_8bZ-K",
  "hide": "hJA42",
  "horizontalScrollbar": "YkM24"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
